import React, { useState } from "react";
import { Button, Col, Row, Tab, Tabs } from "react-bootstrap";
import { browserName } from "react-device-detect";
import DocumentMeta from "react-document-meta";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import HeaderBanner from "../Components/HeaderBanner";
import Config from "../config.json";
import Addon from "../Images/add-on.png";
import Chrome from "../Images/chrome.png";
import FireFox from "../Images/firefox.png";
import edge from "../Images/edge.png";

const body = (
  <>
    به شما امکان می‌دهد صفحات وب، کتاب، مقالات تخصصی و منابع دیگر را
    <br /> از طریق وب‌گاه‌های اطلاعات کتابشناختی و کتابخانه‌ای به کتابخانه
    پژوهیار اضافه کنید. <br />
    این افزونه ها برای سه مرورگر پر کاربرد کروم، فایرفاکس و Edge فراهم شده است.
  </>
);

const title = "افزونه مرورگرهای پژوهیار";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | افزونه مرورگر",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const ACCEPTABLE_BROWSERS = ["chrome", "firefox", "edge"];

const Extension = () => {
  const { hash } = useLocation();

  const tab = hash
    ? hash.replace("#", "").toLocaleLowerCase()
    : browserName.toLowerCase();

  const defaultTab = ACCEPTABLE_BROWSERS.includes(tab) ? tab : "chrome";
  const [activeTab, setActiveTab] = useState(defaultTab);

  const manualGuideTab = activeTab;
  const manualGuideContent = {
    chrome: {
      intro:
        "اگر نصب افزونه از Chrome Web Store برای شما امکان‌پذیر نبود، می‌توانید فایل افزونه کروم را به‌صورت مستقیم دانلود کرده و آن را به‌صورت دستی در مرورگر کروم نصب کنید.",
      downloadHref:
        "https://dl.pajoohyar.com/chrome_extension/chrome.zip",
      downloadLabel: "دانلود مستقیم افزونه کروم (ZIP)",
      stepsTitle: "مراحل نصب دستی افزونه در کروم:",
      steps: [
        "فایل ZIP افزونه را دانلود کرده و از حالت فشرده خارج کنید.",
        <>
          مرورگر کروم را باز کرده و وارد صفحه
          {" "}
          <span dir="ltr">chrome://extensions</span>
          {" "}
          شوید.
        </>,
        <>
          گزینه
          {" "}
          <strong>Developer mode</strong>
          {" "}
          را در بالای صفحه فعال کنید.
        </>,
        <>
          روی دکمه
          {" "}
          <strong>Load unpacked</strong>
          {" "}
          کلیک کنید.
        </>,
        "پوشه‌ای را انتخاب کنید که فایل‌های استخراج‌شده افزونه داخل آن قرار دارد.",
        <>
          مطمئن شوید پوشه‌ای را انتخاب می‌کنید که فایل
          {" "}
          <span dir="ltr">manifest.json</span>
          {" "}
          داخل آن وجود داشته باشد.
        </>,
      ],
      doneMessage:
        "پس از انجام این مراحل، افزونه پژوهیار به کروم اضافه می‌شود و آماده استفاده خواهد بود.",
    },
    edge: {
      intro:
        "اگر نصب افزونه از Microsoft Edge Add-ons برای شما امکان‌پذیر نبود، می‌توانید فایل افزونه Edge را به‌صورت مستقیم دانلود کرده و آن را به‌صورت دستی در مرورگر Edge نصب کنید.",
      downloadHref:
        "https://dl.pajoohyar.com/chrome_extension/chrome.zip",
      downloadLabel: "دانلود مستقیم افزونه Edge (ZIP)",
      stepsTitle: "مراحل نصب دستی افزونه در Edge:",
      steps: [
        "فایل ZIP افزونه را دانلود کرده و از حالت فشرده خارج کنید.",
        <>
          مرورگر Edge را باز کرده و وارد صفحه
          {" "}
          <span dir="ltr">edge://extensions</span>
          {" "}
          شوید.
        </>,
        <>
          گزینه
          {" "}
          <strong>Developer mode</strong>
          {" "}
          را فعال کنید.
        </>,
        <>
          روی دکمه
          {" "}
          <strong>Load unpacked</strong>
          {" "}
          کلیک کنید.
        </>,
        "پوشه‌ای را انتخاب کنید که فایل‌های استخراج‌شده افزونه داخل آن قرار دارد.",
        <>
          مطمئن شوید پوشه‌ای را انتخاب می‌کنید که فایل
          {" "}
          <span dir="ltr">manifest.json</span>
          {" "}
          داخل آن وجود داشته باشد.
        </>,
      ],
      doneMessage:
        "پس از انجام این مراحل، افزونه پژوهیار به Edge اضافه می‌شود و آماده استفاده خواهد بود.",
    },
    firefox: {
      intro:
        "اگر نصب افزونه از Firefox Add-ons برای شما امکان‌پذیر نبود، می‌توانید فایل افزونه فایرفاکس را به‌صورت مستقیم دانلود کرده و آن را به‌صورت دستی در مرورگر فایرفاکس نصب کنید.",
      downloadHref:
        "https://dl.pajoohyar.com/firefox_extension/pajoohyar-firefox.xpi",
      downloadLabel: "دانلود مستقیم افزونه فایرفاکس (XPI)",
      stepsTitle: "مراحل نصب دستی افزونه در فایرفاکس:",
      steps: [
        <>
          فایل افزونه را با پسوند
          {" "}
          <span dir="ltr">XPI</span>
          {" "}
          دانلود کنید.
        </>,
        "مرورگر فایرفاکس را باز نگه دارید.",
        <>
          فایل دانلودشده را با ماوس بگیرید و داخل پنجره فایرفاکس رها کنید
          {" "}
          <span dir="ltr">(Drag & Drop)</span>
          .
        </>,
        "در پیام نمایش‌داده‌شده، نصب افزونه را تأیید کنید.",
        "در صورت نمایش درخواست مجوز، دسترسی‌های افزونه را بررسی و تأیید کنید.",
      ],
      doneMessage:
        "پس از انجام این مراحل، افزونه پژوهیار به فایرفاکس اضافه می‌شود و آماده استفاده خواهد بود.",
    },
  };
  const manualGuide = manualGuideContent[manualGuideTab];

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner
        header_color="#eee"
        image={Addon}
        title={title}
        body={body}
      />
      <Row className="justify-content-center mx-0" style={{ marginTop: 20 }}>
        <Col md={8} sm={12}>
          <p className="text-center">
            با توجه به مرورگر مورد استفاده خود افزونه پژوهیار را نصب کنید. برای
            اطلاع بیشتر از افزونه مرورگرهای پژوهیار، می‌توانید به
            <Link to="/help/14"> راهنمای افزونه‌های پژوهیار </Link> مراجعه کنید.
            همچنین می‌توانید برای مشاهده فهرست پایگاه‌های اطلاعاتی که امکان
            ذخیره منابع را با استفاده از افزونه‌ها را به شما می‌دهند، به صفحه
            <Link to="/supported-sites"> پایگاه پشتیبانی شده </Link> پژوهیار
            مراجعه کنید.
          </p>
        </Col>
      </Row>
      <Row className="justify-content-center mx-0">
        <Col>
          <Tabs
            activeKey={activeTab}
            onSelect={selectedKey => {
              if (selectedKey && ACCEPTABLE_BROWSERS.includes(selectedKey)) {
                setActiveTab(selectedKey);
              }
            }}
            id="uncontrolled-tab-example"
            className="extensions-download-links justify-content-center"
            style={{ marginTop: 20 }}>
            <Tab
              eventKey="firefox"
              title={
                <span className="addon-tabs">
                  <img alt="firefox" src={FireFox} />
                </span>
              }>
              <Row style={{ padding: "20px 10px" }}>
                <Col>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    افزونه فایرفاکس امکان ذخیره نتایج حاصل از تحقیقات شما را در
                    قالب مترجم‌های شناخته شده در پژوهیار فراهم می‌کند.
                  </Row>

                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    <Button
                      variant="success"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://addons.mozilla.org/en-US/firefox/addon/pajoohyar/?src=search">
                      دانلود از فایرفاکس
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="chrome"
              title={
                <span className="addon-tabs">
                  <img alt="chrome" src={Chrome} />
                </span>
              }>
              <Row style={{ padding: "20px 10px" }}>
                <Col>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    افزونه کروم امکان ذخیره نتایج حاصل از تحقیقات شما را در قالب
                    مترجم‌های شناخته‌شده در پژوهیار فراهم می‌کند.
                  </Row>

                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    <Button
                      variant="success"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://chromewebstore.google.com/detail/%D8%B1%D8%A7%D8%A8%D8%B7-%D9%BE%DA%98%D9%88%D9%87%DB%8C%D8%A7%D8%B1/epeaammaiaknlihkglijkmdfcpohgpid?hl=en-US&utm_source=ext_sidebar">
                      دانلود از کروم استور
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="edge"
              title={
                <span className="addon-tabs">
                  <img
                    alt="edge"
                    src={edge}
                    style={{ width: 100, height: 100 }}
                  />
                </span>
              }>
              <Row style={{ padding: "20px 10px" }}>
                <Col>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0", textAlign: "right" }}>
                    افزونه Edge امکان ذخیره نتایج حاصل از تحقیقات شما را در قالب
                    مترجم‌های شناخته شده در پژوهیار فراهم می‌کند.
                  </Row>
                  <Row
                    className="justify-content-center"
                    style={{ padding: "20px 0" }}>
                    <Button
                      variant="success"
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://microsoftedge.microsoft.com/addons/detail/%D8%B1%D8%A7%D8%A8%D8%B7-%D9%BE%DA%98%D9%88%D9%87%DB%8C%D8%A7%D8%B1/adcfppnkaeeengcanndhmflboobmhbfa">
                      دانلود از مایکروسافت استور
                    </Button>
                  </Row>
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Col>
      </Row>
      <Row className="justify-content-center mx-0">
        <Row className="justify-content-center" style={{ padding: "10px 0 30px 0" }}>
          <Col md={10} sm={12}>
            <div
              style={{
                border: "1px solid #dcdcdc",
                borderRadius: 12,
                padding: 20,
                backgroundColor: "#fafafa",
                textAlign: "right",
                lineHeight: 2,
              }}>
              <p 
              style={{
                fontSize: "30px",
                fontWeight: "bold",
                color: "red"
              }}>
                توجه
              </p>
              <p>{manualGuide.intro}</p>

              <div
                className="d-flex justify-content-center"
                style={{ padding: "10px 0 20px 0" }}>
                <Button
                  variant="outline-success"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={manualGuide.downloadHref}>
                  {manualGuide.downloadLabel}
                </Button>
              </div>

              <p style={{ marginBottom: 8 }}>
                {manualGuide.stepsTitle}
              </p>
              <ol style={{ paddingRight: 20, marginBottom: 16 }}>
                {manualGuide.steps.map((step, index) => (
                  <li key={`${manualGuideTab}-step-${index}`}>{step}</li>
                ))}
              </ol>

              <p style={{ marginBottom: 0 }}>
                {manualGuide.doneMessage}
              </p>
            </div>
          </Col>
        </Row>
        <Col sm={12} md={8}>
          <p style={{ textAlign: "center" }}>
            با دانلود افزونه پژوهیار می‌توانید از{" "}
            <Link to="/supported-sites"> پایگاه پشتیبانی شده </Link>
            پژوهیار برای ذخیره اطلاعات استفاده کنید.
          </p>
        </Col>
      </Row>
    </DocumentMeta>
  );
};

export default Extension;
